// Keywords for demo video matching (from legacy system)

// Primary keywords for rendering demos
export const RENDERING_KEYWORDS = ['rendering', 'render'];

// Demo keyword that must be present
export const DEMO_KEYWORD = 'demo';

// Additional trigger keywords (can extend as needed)
export const SHOW_KEYWORDS = ['show', 'display', 'present'];
